import React, { useEffect, useState } from "react";
import CookieConsent from "react-cookie-consent";
import ContactSection from "../components/ContactSection";
import CoreSection from "../components/CoreSection";
import EcosystemSection from "../components/EcosystemSection";
import FeaturesSection from "../components/FeaturesSection";
import HeroSection from "../components/HeroSection";
import HowSection from "../components/HowSection";
import IntroduceSection from "../components/IntroduceSection";
import WhySection from "../components/WhySection";

const HomePage = () => {
  const [isShowFade, setIsShowFade] = useState(false);

  const handleScroll = () => {
    if (
      window.innerHeight + window.scrollY >=
      document.body.scrollHeight - 60
    ) {
      setIsShowFade(false);
    } else {
      setIsShowFade(true);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div className={`fade-mask ${isShowFade ? "" : "bottom"}`}>
      <HeroSection />
      <IntroduceSection />
      <HowSection />
      <WhySection />
      <FeaturesSection />
      <CoreSection />
      <EcosystemSection />
      <ContactSection />

      <CookieConsent
        location="bottom"
        cookieName="cookies-policy"
        contentClasses="text-capitalize"
        style={{ background: "#2B373B", fontSize: "14px" }}
        buttonText="Accept all"
        buttonStyle={{
          background: "#269adc",
          color: "#fff",
          borderRadius: "4px",
          fontSize: "14px",
          fontWeight: "600",
          margin: "unset",
          marginRight: "14px"
        }}
        enableDeclineButton
        declineButtonText="I decline"
        declineButtonStyle={{
          background: "red",
          color: "#fff",
          borderRadius: "4px",
          fontSize: "14px",
          fontWeight: "600"
        }}
      >
        This website uses cookies to improve your online experience. They were
        placed on your browser when you launched this website. You can read more
        detail by clicking &nbsp;
        <a href="/privacy-policy">
          <span style={{ color: "#269adc", textDecoration: "underline" }}>
            Cookies Policy
          </span>
        </a>
      </CookieConsent>
    </div>
  );
};

export default HomePage;
